import type { RouteRecordRaw } from 'vue-router';

export const baselineRoutes: RouteRecordRaw[] = [
  {
    name: 'baseline-index',
    component: () => import('../pages/index.vue'),
    path: '/references/baselines',
    meta: {
      middleware: 'auth',
    },
  },
  {
    name: 'baseline-create',
    component: () => import('../pages/create/index.vue'),
    path: '/references/baselines/create',
    meta: {
      middleware: 'auth',
    },
    children: [
      {
        name: 'baseline-create-energy-use',
        component: () => import('../pages/create/tabs/energyUseStep.vue'),
        path: 'energy-use',
      },
      {
        name: 'baseline-create-variables',
        component: () => import('../pages/create/tabs/baselineVariableStep.vue'),
        path: 'variables',
      },
      {
        name: 'baseline-create-model-selection',
        component: () => import('../pages/create/tabs/modelSelectionStep.vue'),
        path: 'model-selection',
      },
    ],
  },
  {
    name: 'baseline-edit',
    component: () => import('../pages/edit/index.vue'),
    path: '/references/baselines/edit/:id',
    meta: {
      middleware: 'auth',
    },
    children: [
      {
        name: 'baseline-edit-training-period',
        component: () => import('../pages/edit/tabs/trainingPeriodStep.vue'),
        path: 'training-period',
      },
      {
        name: 'baseline-edit-review',
        component: () => import('../pages/edit/tabs/reviewStep.vue'),
        path: 'review',
      },
      {
        name: 'baseline-edit-validation',
        component: () => import('../pages/edit/tabs/validationStep.vue'),
        path: 'validation',
      },
    ],
  },
];
